// extracted by mini-css-extract-plugin
module.exports = {"conteiner":"HousesList_conteiner__3BdJz"};